
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-38c705e1&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./updateItem.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./updateItem.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-38c705e1!../../node_modules/vue-loader/lib/selector?type=template&index=0!./updateItem.vue"),
  /* scopeId */
  "data-v-38c705e1",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/updateItem.vue
// module id = 628
// module chunks = 1